import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const sidebarSelector = state => state.app.sidebar;

const isSidebarMinimized = createSelector(
  sidebarSelector,
  sidebar => true
);

export default isSidebarMinimized;



// WEBPACK FOOTER //
// ./src/_selectors/appSelectors/isSidebarCollapsed.js